import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import { memo } from 'react';
import { areEqual } from 'react-window';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var VirtualizedItem = /*#__PURE__*/memo(function (_ref) {
  var data = _ref.data,
      index = _ref.index,
      virtualizedStyles = _ref.style,
      _ref$showSortHandler = _ref.showSortHandler,
      showSortHandler = _ref$showSortHandler === void 0 ? false : _ref$showSortHandler;
  var items = data.items,
      itemRenderer = data.itemRenderer,
      isItemMoving = data.isItemMoving;

  var _ref2 = items[index] || {},
      item = _ref2.item,
      animatedStyles = _ref2.props,
      key = _ref2.key;

  if (!item) return null;
  return itemRenderer({
    index: index,
    key: key,
    item: item,
    showSortHandler: showSortHandler,
    style: isItemMoving ? _objectSpread(_objectSpread({}, animatedStyles), virtualizedStyles) : virtualizedStyles
  });
}, areEqual);

export default VirtualizedItem;
//# sourceMappingURL=VirtualizedItem.js.map
